import { ActionTypes as action } from "./action-types";
import surveyService from "../../../api/surveyService";


const actions = {
    async submitSurveyResult({ dispatch }, data) {
        const result = await surveyService.submitSurveyResult(data);
        return
    },
    async getSurveyList({ commit }) {
        const data = await surveyService.getSurveyList();
        commit(action.GET_SURVEY_LIST, data);
        return
    },
    async getSurveyById({ dispatch, commit }, id) {
        const data = await surveyService.getSurveyById(id);
        commit(action.GET_SURVEY_BY_ID, data);
        return data
    },
    async getSurveySummaryById({ dispatch, commit }, id) {
        const data = await surveyService.getSurveyById(id);
        commit(action.GET_SURVEY_SUMMARY_BY_ID, data);
        return data
    },
    async createSurvey({ dispatch, commit }, data) {
        const result = await surveyService.createSurvey(data);
        commit(action.RESET_SURVEY_OBJECT);
        return result
    },
    async updateSurvey({ dispatch, commit }, data) {
        await surveyService.updateSurvey(data);
        commit(action.RESET_SURVEY_OBJECT);
        return
    },
    async deleteSurvey({ dispatch, commit }, id) {
        await surveyService.deleteSurvey(id);
        return
    },
    async getSurveyResult({ }, params) {
        const data = await surveyService.getLoggedUserSurveyResult(params.surveyid);
        return data
    },
    async getResponseBySurveyId({ dispatch, commit }, surveyid) {
        const data = await surveyService.getResponseBySurveyId(surveyid);
        commit(action.GET_SURVEY_RESPONSE_RESULT, data);
        return data
    },
    async getSilentResponseBySurveyId({ dispatch, commit }, surveyid) {
        const data = await surveyService.getSilentResponseBySurveyId(surveyid);
        commit(action.GET_SURVEY_RESPONSE_RESULT, data);
        return data
    },
    async getResponseSummaryBySurveyId({ dispatch, commit }, surveyid) {
        const data = await surveyService.getResponseBySurveyId(surveyid);
        commit('setDefaultCompairResult', data);
        return data
    },
    async getSurveyTargetUsersList({ dispatch, commit }) {
        const data = await surveyService.getSurveyTargetUsersList();
        return data
    },
    async getSurveyRespondersDetails({ }, surveyid) {
        const result = await surveyService.getSurveyRespondersDetails(surveyid);
        return result
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
    setSurveySelector({ commit }, surveyid) {
        commit('setSurveySelector', surveyid);
    },
    setDefaultDetails({ commit }, data) {
        commit('setDefaultDetails', data);
    },
    setDefaultCompairResult({ commit }, data) {
        commit('setDefaultCompairResult', data);
    },
};

export default actions;
